/**
 * Supported country codes for the phone-login dropdown.
 * Albania is pinned first (default selection).
 */
export const COUNTRIES = [
    { iso: "AL", name: "Albania", dial: "+355", flag: "🇦🇱", placeholder: "68 123 4567" },
    { iso: "GR", name: "Greece", dial: "+30", flag: "🇬🇷", placeholder: "69 1234 5678" },
    { iso: "IN", name: "India", dial: "+91", flag: "🇮🇳", placeholder: "98765 43210" },
    { iso: "US", name: "United States", dial: "+1", flag: "🇺🇸", placeholder: "555 123 4567" },
    { iso: "GB", name: "United Kingdom", dial: "+44", flag: "🇬🇧", placeholder: "7700 900123" },
    { iso: "ES", name: "Spain", dial: "+34", flag: "🇪🇸", placeholder: "612 345 678" },
    { iso: "IT", name: "Italy", dial: "+39", flag: "🇮🇹", placeholder: "320 123 4567" },
    { iso: "ME", name: "Montenegro", dial: "+382", flag: "🇲🇪", placeholder: "67 123 456" },
    { iso: "MK", name: "North Macedonia", dial: "+389", flag: "🇲🇰", placeholder: "71 123 456" },
    { iso: "BG", name: "Bulgaria", dial: "+359", flag: "🇧🇬", placeholder: "87 123 4567" },
];

export const DEFAULT_COUNTRY = COUNTRIES[0]; // Albania

/** Strip whitespace, dashes, parens; keep digits only. Leading 0 is dropped (local trunk). */
export const cleanLocal = (raw) =>
    String(raw || "").replace(/\D/g, "").replace(/^0+/, "");

/** Concatenate dial code + local digits into E.164 ("+355681234567"). */
export const buildE164 = (dial, local) => `${dial}${cleanLocal(local)}`;
